(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setup = (track) => {
    if (track.dataset.heRouteReady === 'true') return;

    const slides = [...track.querySelectorAll('[data-he-route-slide]')];
    const shell = track.closest('section');
    const dots = shell ? [...shell.querySelectorAll('[data-he-route-dot]')] : [];
    if (slides.length < 2) return;

    track.dataset.heRouteReady = 'true';
    let current = 0;
    let timer;
    let resumeTimer;

    const nearestSlide = () => {
      const center = track.scrollLeft + track.clientWidth / 2;
      return slides.reduce((best, slide, index) => {
        const distance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity }).index;
    };

    const setActive = (index) => {
      current = index;
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    };

    const goTo = (index, smooth = true) => {
      if (!mobileQuery.matches) return;
      const next = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[next].offsetLeft - track.offsetLeft, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
      setActive(next);
    };

    const stop = () => {
      window.clearInterval(timer);
      window.clearTimeout(resumeTimer);
    };

    const start = () => {
      stop();
      if (!mobileQuery.matches || reduceMotion.matches || document.hidden) return;
      timer = window.setInterval(() => goTo(current + 1), 5200);
    };

    let scrollTimer;
    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => setActive(nearestSlide()), 90);
    }, { passive: true });

    track.addEventListener('pointerdown', stop, { passive: true });
    track.addEventListener('pointerup', () => {
      resumeTimer = window.setTimeout(start, 2200);
    }, { passive: true });
    track.addEventListener('touchend', () => {
      resumeTimer = window.setTimeout(start, 2200);
    }, { passive: true });

    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      stop();
      goTo(index);
      resumeTimer = window.setTimeout(start, 2600);
    }));

    document.addEventListener('visibilitychange', start);
    mobileQuery.addEventListener?.('change', start);
    start();
  };

  const init = (root = document) => root.querySelectorAll('[data-he-route-slider]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
